// extracted by mini-css-extract-plugin
export var activityContainer = "_jz-0";
export var typingIndicatorContainer = "_jz-1";
export var typingIndicatorDot = "_jz-2";
export var wave = "_jz-3";